<container-element [ngSwitch]="isServer()">
  <app-job-ssr *ngSwitchCase="true"></app-job-ssr>
  <app-job-bsr *ngSwitchDefault></app-job-bsr>
</container-element>
